import { CFDStatus } from "features/cfd/state/cfdAtoms";
import { Study } from "features/optimization/state/studyAtoms";
import { OBJECTIVE_PRESETS, ObjectiveKey, ObjectivePresetId } from "shared/domain/objectivePresets";

export const buildCFDStatusFromStudy = (
  study: Study,
  presetId?: ObjectivePresetId,
  index: number = 0
): CFDStatus => {
  const resolvedPresetId = presetId ?? study.presetId;
  const preset = OBJECTIVE_PRESETS[resolvedPresetId];

  const objectives: ObjectiveKey[] = preset.objectives.map((meta) => meta.key);
  const cfd_id: Record<ObjectiveKey, string> = {} as Record<ObjectiveKey, string>;
  const value: Record<ObjectiveKey, number> = {} as Record<ObjectiveKey, number>;
  const status: Record<ObjectiveKey, string> = {} as Record<ObjectiveKey, string>;

  preset.objectives.forEach((meta, idx) => {
    const cfdList =
      idx === 0 ? study.cfd_id_list?.cfd_id_list_1 : study.cfd_id_list?.cfd_id_list_2;
    const valList =
      idx === 0 ? study.objective_list?.objective_list_1 : study.objective_list?.objective_list_2;
    cfd_id[meta.key] = cfdList?.[index] ?? '';
    const num = Number(valList?.[index]);
    value[meta.key] = Number.isFinite(num) ? num : NaN;
    status[meta.key] = '';
  });

  return {
    status_code: study.status_code,
    name: study.name,
    presetId: resolvedPresetId,
    objectives,
    cfd_id,
    value,
    status,
    error_code: study.error_code_list?.error_code_list_1?.[index] ?? null,
  };
};
